function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase, { LARGE_VIEWBOX } from '../shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function SocialGoogleColorIcon(props) {
  return ___EmotionJSX(IconBase, _extends({
    width: "32",
    height: "32",
    viewBox: LARGE_VIEWBOX
  }, props), ___EmotionJSX("g", {
    clipPath: "url(#clip0_3493_7605)"
  }, ___EmotionJSX("path", {
    d: "M29.3342 16.3066C29.3342 15.4003 29.2593 14.489 29.0993 13.5974H16.2695V18.7317H23.6166C23.3117 20.3876 22.3321 21.8524 20.8977 22.7832V26.1146H25.2809C27.8548 23.7924 29.3342 20.3631 29.3342 16.3066Z",
    fill: "#147AE2"
  }), ___EmotionJSX("path", {
    d: "M16.2683 29.3325C19.9368 29.3325 23.0306 28.1518 25.2847 26.1137L20.9014 22.7824C19.6819 23.5956 18.1076 24.0561 16.2733 24.0561C12.7248 24.0561 9.716 21.7095 8.63644 18.5544H4.11328V21.9887C6.42234 26.491 11.1254 29.3325 16.2683 29.3325Z",
    fill: "#008A08"
  }), ___EmotionJSX("path", {
    d: "M8.63304 18.5545C8.06327 16.8986 8.06327 15.1055 8.63304 13.4496V10.0154H4.11488C2.18567 13.7828 2.18567 18.2214 4.11488 21.9888L8.63304 18.5545Z",
    fill: "#FFCA44"
  }), ___EmotionJSX("path", {
    d: "M16.2683 7.94373C18.2075 7.91433 20.0818 8.6296 21.4862 9.94256L25.3696 6.13596C22.9106 3.87258 19.647 2.62821 16.2683 2.6674C11.1254 2.6674 6.42234 5.50888 4.11328 10.016L8.63144 13.4503C9.706 10.2904 12.7198 7.94373 16.2683 7.94373Z",
    fill: "#EA4335"
  })), ___EmotionJSX("defs", null, ___EmotionJSX("clipPath", {
    id: "clip0_3493_7605"
  }, ___EmotionJSX("rect", {
    width: "32",
    height: "32",
    fill: "white"
  }))));
}